import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { projectAPI } from "../../services/api";
import "./JoinProject.css";
import { FiLogIn, FiArrowLeft } from "react-icons/fi";
import { useLanguage } from "../../contexts/LanguageContext";

// 다국어 지원을 위한 번역 객체
const translations = {
  ko: {
    backToDashboard: "돌아가기",
    joinProject: "프로젝트 참여",
    invitationCode: "초대 코드",
    invitationCodePlaceholder:
      "프로젝트 운영자에게 받은 초대 코드를 입력해주세요.",
    joinProjectButton: "프로젝트 참가",
    processing: "처리 중...",
    joinFailed: "프로젝트 참여에 실패했습니다.",
    joinSuccess: "프로젝트에 성공적으로 참여했습니다.",
  },
  en: {
    backToDashboard: "Back",
    joinProject: "Join Project",
    invitationCode: "Invitation Code",
    invitationCodePlaceholder:
      "Enter the invitation code received from the project administrator.",
    joinProjectButton: "Join Project",
    processing: "Processing...",
    joinFailed: "Failed to join the project.",
    joinSuccess: "Successfully joined the project.",
  },
  ja: {
    backToDashboard: "戻る",
    joinProject: "プロジェクトに参加",
    invitationCode: "招待コード",
    invitationCodePlaceholder:
      "プロジェクト管理者から受け取った招待コードを入力してください。",
    joinProjectButton: "プロジェクトに参加",
    processing: "処理中...",
    joinFailed: "プロジェクトへの参加に失敗しました。",
    joinSuccess: "プロジェクトに正常に参加しました。",
  },
  "zh-CN": {
    backToDashboard: "返回",
    joinProject: "加入项目",
    invitationCode: "邀请码",
    invitationCodePlaceholder: "请输入从项目管理员处获得的邀请码。",
    joinProjectButton: "加入项目",
    processing: "处理中...",
    joinFailed: "加入项目失败。",
    joinSuccess: "成功加入项目。",
  },
  "zh-TW": {
    backToDashboard: "返回",
    joinProject: "加入專案",
    invitationCode: "邀請碼",
    invitationCodePlaceholder: "請輸入從專案管理員處獲得的邀請碼。",
    joinProjectButton: "加入專案",
    processing: "處理中...",
    joinFailed: "加入專案失敗。",
    joinSuccess: "成功加入專案。",
  },
  it: {
    backToDashboard: "Indietro",
    joinProject: "Partecipa al Progetto",
    invitationCode: "Codice di Invito",
    invitationCodePlaceholder:
      "Inserisci il codice di invito ricevuto dall'amministratore del progetto.",
    joinProjectButton: "Partecipa al Progetto",
    processing: "Elaborazione in corso...",
    joinFailed: "Impossibile partecipare al progetto.",
    joinSuccess: "Hai partecipato con successo al progetto.",
  },
  fr: {
    backToDashboard: "Retour",
    joinProject: "Rejoindre le Projet",
    invitationCode: "Code d'Invitation",
    invitationCodePlaceholder:
      "Entrez le code d'invitation reçu de l'administrateur du projet.",
    joinProjectButton: "Rejoindre le Projet",
    processing: "Traitement en cours...",
    joinFailed: "Échec de l'adhésion au projet.",
    joinSuccess: "Vous avez rejoint le projet avec succès.",
  },
  de: {
    backToDashboard: "Zurück",
    joinProject: "Projekt Beitreten",
    invitationCode: "Einladungscode",
    invitationCodePlaceholder:
      "Geben Sie den Einladungscode ein, den Sie vom Projektadministrator erhalten haben.",
    joinProjectButton: "Projekt Beitreten",
    processing: "Verarbeitung...",
    joinFailed: "Beitritt zum Projekt fehlgeschlagen.",
    joinSuccess: "Erfolgreich dem Projekt beigetreten.",
  },
  es: {
    backToDashboard: "Volver",
    joinProject: "Unirse al Proyecto",
    invitationCode: "Código de Invitación",
    invitationCodePlaceholder:
      "Ingrese el código de invitación recibido del administrador del proyecto.",
    joinProjectButton: "Unirse al Proyecto",
    processing: "Procesando...",
    joinFailed: "Error al unirse al proyecto.",
    joinSuccess: "Se ha unido al proyecto con éxito.",
  },
  ru: {
    backToDashboard: "Назад",
    joinProject: "Присоединиться к Проекту",
    invitationCode: "Код Приглашения",
    invitationCodePlaceholder:
      "Введите код приглашения, полученный от администратора проекта.",
    joinProjectButton: "Присоединиться к Проекту",
    processing: "Обработка...",
    joinFailed: "Не удалось присоединиться к проекту.",
    joinSuccess: "Вы успешно присоединились к проекту.",
  },
  pt: {
    backToDashboard: "Voltar",
    joinProject: "Participar do Projeto",
    invitationCode: "Código de Convite",
    invitationCodePlaceholder:
      "Digite o código de convite recebido do administrador do projeto.",
    joinProjectButton: "Participar do Projeto",
    processing: "Processando...",
    joinFailed: "Falha ao entrar no projeto.",
    joinSuccess: "Você entrou no projeto com sucesso.",
  },
  ar: {
    backToDashboard: "رجوع",
    joinProject: "الانضمام للمشروع",
    invitationCode: "رمز الدعوة",
    invitationCodePlaceholder: "أدخل رمز الدعوة المستلم من مسؤول المشروع.",
    joinProjectButton: "الانضمام للمشروع",
    processing: "جاري المعالجة...",
    joinFailed: "فشل الانضمام إلى المشروع.",
    joinSuccess: "تم الانضمام إلى المشروع بنجاح.",
  },
  hi: {
    backToDashboard: "वापस जाएं",
    joinProject: "प्रोजेक्ट में शामिल हों",
    invitationCode: "आमंत्रण कोड",
    invitationCodePlaceholder:
      "प्रोजेक्ट प्रशासक से प्राप्त आमंत्रण कोड दर्ज करें।",
    joinProjectButton: "प्रोजेक्ट में शामिल हों",
    processing: "प्रक्रिया जारी है...",
    joinFailed: "प्रोजेक्ट में शामिल होने में विफल रहा।",
    joinSuccess: "आप सफलतापूर्वक प्रोजेक्ट में शामिल हो गए हैं।",
  },
};

const JoinProject = () => {
  const navigate = useNavigate();
  const { currentLanguage } = useLanguage();
  const [invitationCode, setInvitationCode] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");

  // 현재 언어에 따른 텍스트 가져오기
  const getText = (key) => {
    return translations[currentLanguage]?.[key] || translations["en"][key];
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!invitationCode.trim()) return;

    setIsSubmitting(true);
    setError("");
    setSuccess("");

    try {
      const response = await projectAPI.joinProject(invitationCode.trim());
      if (!response.success) {
        throw new Error(response.message || getText("joinFailed"));
      }
      setSuccess(getText("joinSuccess"));
      // 대시보드로 이동 (잠시 후)
      setTimeout(() => navigate("/dashboard"), 1500);
    } catch (err) {
      const errMsg =
        err.response?.data?.message || err.message || JSON.stringify(err);
      setError(errMsg);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="join-project-container">
      <button className="back-button" onClick={() => navigate(-1)}>
        <FiArrowLeft /> {getText("backToDashboard")}
      </button>
      <h1>{getText("joinProject")}</h1>

      <form className="join-project-form" onSubmit={handleSubmit}>
        <label htmlFor="inviteCode">{getText("invitationCode")}</label>
        <input
          id="inviteCode"
          type="text"
          placeholder={getText("invitationCodePlaceholder")}
          value={invitationCode}
          onChange={(e) => setInvitationCode(e.target.value)}
          required
        />
        {error && <p className="error-message">{error}</p>}
        {success && <p className="success-message">{success}</p>}
        <button type="submit" className="submit-button" disabled={isSubmitting}>
          <FiLogIn style={{ marginRight: 6 }} />
          {isSubmitting ? getText("processing") : getText("joinProjectButton")}
        </button>
      </form>
    </div>
  );
};

export default JoinProject;
